import { CircleCheckIcon, Typography } from '@/components/atoms';
import { TextHeader } from '@/components/molecules/header/TextHeader';
import { useTranslation, useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export default function Notifications() {
    const { t } = useTranslation();
    const colors = useUIColors();

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundLevel2 }]}>
            <TextHeader title={t('notifications.title') || 'Notifications'} />
            <View style={styles.emptyState}>
                <View style={styles.iconContainer}>
                    <CircleCheckIcon size={80} color={colors.fontTertiary} />
                </View>
                <Typography variant="title2" color="primary" style={styles.message}>
                    {t('notifications.upToDate') || 'You are up to date!'}
                </Typography>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    emptyState: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 24,
        paddingHorizontal: 24,
        gap: 32,
    },
    iconContainer: {
        width: 88,
        height: 88,
        alignItems: 'center',
        justifyContent: 'center',
    },
    message: {
        textAlign: 'center',
    },
});
